import { toHtmlNode } from '@/utils/toHtmlNode';
import { useToastAPI } from '@moneyforward/ap-frontend-components';
import { useEffect } from 'react';

const DEFAULT_FLASH_TOAST_DURATION = 3;

type ToastType = 'error' | 'success';

const FLASH_TYPE_TO_TOAST: Record<string, ToastType> = {
  notice: 'success',
  alert: 'error',
};

type UseFlashToastOptions = {
  duration?: number;
};

export const useFlashToast = (options?: UseFlashToastOptions) => {
  const notify = useToastAPI();
  const duration = options?.duration ?? DEFAULT_FLASH_TOAST_DURATION;

  useEffect(() => {
    Object.entries(FLASH_TYPE_TO_TOAST).forEach(([flashType, toastType]) => {
      const key = `toast-${flashType}-message`;
      const message = sessionStorage.getItem(key);
      if (!message) return;
      const opts = { title: toHtmlNode(message), duration };

      if (toastType === 'error') {
        notify.error(opts);
      } else {
        notify.success(opts);
      }
      sessionStorage.removeItem(key);
    });
  }, [notify, duration]);
};
